import { Platform } from 'react-native'

export const IS_PROD = process.env.NODE_ENV === 'production'

export const BREAKPOINTS = {
    sm: 380,
    md: 600,
    lg: 768,
    xl: 900,
    monitor: 1000,
} as const

function resolvePbAddr(): string {
    if (Platform.OS === 'web') return window.location.origin
    if (IS_PROD) return 'https://jobtimey.com'
    return 'https://localhost:8100'
}

export const PB_SERVER_ADDR = resolvePbAddr()

export const GOOGLE_MAPS_API_KEY =
    process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY || 'AIzaSyAeOj2AKX1zsuhPy6S2WtaUOXc7v338Ruk'

if (IS_PROD && GOOGLE_MAPS_API_KEY == null)
    throw new Error('No EXPO_PUBLIC_GOOGLE_MAPS_API_KEY env var set')

export const HIDE_ERRORS = !!process.env.EXPO_PUBLIC_HIDE_ERRORS
